/**
 * Parse query string. Supports normal `a=1&b=2` and legacy chained `?a=1?b=2` used in this app.
 */
export function parseAppQuery(search) {
  const raw = (search || '').replace(/^\?/, '')
  if (!raw) return {}
  const segments = raw.split(/[?&]/).filter(Boolean)
  const out = {}
  for (const seg of segments) {
    const eq = seg.indexOf('=')
    if (eq === -1) continue
    const k = seg.slice(0, eq).trim()
    let v = seg.slice(eq + 1).trim()
    if (!k || v === '') continue
    try {
      v = decodeURIComponent(v.replace(/\+/g, ' '))
    } catch {
      /* keep raw */
    }
    out[k] = v
  }
  return out
}

/** `/simulations/details/:simulationId/:tab` */
export function parseSimulationDetailPath(pathname) {
  const m = (pathname || '').match(/^\/simulations\/details\/([^/]+)\/([^/?#]+)/)
  if (!m) return { simulationId: null, tab: null }
  return { simulationId: m[1], tab: m[2] }
}

export function toNumericId(val) {
  if (val == null || val === '') return null
  const n = Number(val)
  return Number.isFinite(n) ? n : null
}
